import React from 'react'
import * as Styled from './paginationStyled'

const Pagination = (props) => {
  const { count, entries, currentPage, paginationClick } = props
  const beforePages = []
  const afterPages = []
  const pages = []
  const totalPages = Math.ceil(count / entries)
  let paginationStart = 1
  let page = currentPage

  if (count > entries) {
    const pageChange = (e) => {
      const id = e.target.id

      if (typeof count !== 'undefined') {
        if (id === 'first' && page !== 1) {
          page = 1
        } else if (id === 'previous' && page > 1) {
          page -= 1
        } else if (id === 'next' && page < Math.ceil(count / entries)) {
          page += 1
        } else if (id === 'last' && page !== Math.ceil(count / entries)) {
          page = Math.ceil(count / entries)
        } else if (id.slice(0, 4) === 'page') {
          page = parseInt(id.substring(4), 10)
        }

        if (page !== currentPage) {
          paginationClick(page)
        }
      }
    }

    if (page > 2 && totalPages > 5) {
      if (page < totalPages - 2) {
        paginationStart = page - 2
      } else {
        paginationStart = totalPages - 4
      }
    }

    if (totalPages > 5) {
      beforePages.push(
        <Styled.ChangeDiv design={props.design} id="first" onClick={e => pageChange(e)} />,
        <Styled.ChangeDiv design={props.design} id="previous" onClick={e => pageChange(e)} />,
      )
      afterPages.push(
        <Styled.ChangeDiv design={props.design} id="next" onClick={e => pageChange(e)} />,
        <Styled.ChangeDiv design={props.design} id="last" onClick={e => pageChange(e)} />,
      )
    }

    for (let x = paginationStart; x <= totalPages && x < paginationStart + 5; x += 1) {
      pages.push(
        <Styled.NumDiv design={props.design} id={`page${x}`} onClick={e => pageChange(e)} active={x === page}>{x}</Styled.NumDiv>,
      )
    }
  }
  return (
    <Styled.PaginationWrapDiv>
      {beforePages}
      {pages}
      {afterPages}
    </Styled.PaginationWrapDiv>
  )
}

export default Pagination;
